var Mustache = require("mustache")

export default class IcmaDoc {
    constructor() {
        //eslint-disable-next-line
        this.json = `{"pageSize":"LETTER","pageMargins":[72,45,72,45],"content":[{"image":"logo","width":120,"alignment":"center","margin":[0,0,0,14]},{"text":"Independent Contractor Master Agreement","alignment":"center","bold":true,"fontSize":12,"margin":[0,0,0,14]},{"text":"Between","alignment":"center","bold":true,"fontSize":10,"margin":[0,0,0,14]},{"columns":[{"text":["Elite Logistics, Inc\\n","Attn: Brent LaFave\\n","P.O. Box 630122\\n","Littleton, CO  80163-0122\\n","Telephone: 303.994.9633"]},{"text":["Contractor:  {{{userName}}}\\n\\n","DBA:  {{{companyName}}}\\n\\n","Telephone:  {{{phone}}}"],"alignment":"right"}],"margin":[0,0,0,16]},{"text":[{"text":"THIS AGREEMENT ","bold":true},"is between Elite Logistics, Inc. (",{"text":"¨Elite¨","bold":true},") and the above named party (",{"text":"¨Contractor¨","bold":true},") [Individually a “Party” and collectively the “Parties”] effective this {{{invite_dayOrdinal(edate)}}} day of {{{invite_month(edate)}}}, {{{invite_year(edate)}}} (the ",{"text":"¨Effective Date¨","bold":true},")."],"style":"para"},{"text":[{"text":"WHEREAS","bold":true},", Elite provides logistic support to businesses (",{"text":"“Client[s]”","bold":true},{"text":") through independent contractors who use their own rolling equipment, supplies, materials, tools and who provide their own fuel, maintenance, and insurance related to the aforesaid; and\\n\\n"},{"text":"WHEREAS","bold":true},", Contractor is a business separate and apart from Elite with no overlapping ownership or control; and is customarily engaged in a business related to the service to be performed under this Agreement; and,\\n\\n",{"text":"WHEREAS","bold":true},", Contractor provides workers compensation insurance and unemployment insurance for its employees.\\n\\n",{"text":"NOW THEREFORE","bold":true},", in consideration of the covenants and restrictions herein, the Parties agree:\\n"],"style":"para"},{"text":"Section I:  Assignments\\n","style":"section"},{"text":"Elite may present opportunities to Contractor to provide delivery services for Clients (an ¨Assignment¨) setting forth the Client's requirements and needs including the dates and times needed and delivery destination(s) where known.  Contractor shall have the option to accept or reject the Assignment with Clients; however, all Assignments shall be subject to approval of Contractor by the Client.  An assignment will be delivery, or other service, that takes one day or less to complete unless stated otherwise.  An Assignment will not include special deliveries or similar services (generally services that will take four hours or less to complete).","style":"para"},{"text":"Section II:  Subcontract\\n","style":"section"},{"text":"Contractor may fulfill any Assignment by use of its employees or may subcontract an Assignment to a third party.","style":"para"},{"text":"Section III:  Term\\n","style":"section"},{"text":"The term of this Agreement shall commence on the Effective Date and shall be applicable to all Assignments.  Notwithstanding the aforesaid, Elite does not guaranty Contractor any Assignment or reassignment of Contractor to a Client after any Assignment.","style":"para"},{"text":"Section IV:  Disclaimers\\n","style":"section"},{"text":"CONTRACTOR IS NOT ENTITLED TO UNEMPLOYMENT COMPENSATION INSURANCE BENEFITS UNLESS UNEMPLOYMENT COMPENSATION INSURANCE COVERAGE IS PROVIDED BY CONTRACTOR OR SOME OTHER ENTITY;","style":["para","dark"]},{"text":"CONTRACTOR IS OBLIGATED TO PAY FEDERAL AND STATE INCOME TAX ON ANY MONEYS PAID PURSUANT TO THE CONTRACT RELATIONSHIP;","style":["para","dark"]},{"text":"CONTRACTOR IS NOT REQUIRED TO ACCEPT AN ASSIGNMENT;","style":["para","dark"]},{"text":"CONTRACTOR IS NOT REQUIRED TO WORK EXCLUSIVELY FOR ELITE, EXCEPT THAT CONTRACTOR MAY CHOOSE TO WORK EXCLUSIVELY FOR A FINITE PERIOD OF TIME SPECIFIED IN THIS AGREEMENT OR IN AN ASSIGNMENT;","style":["para","dark"]},{"text":"ELITE DOES NOT ESTABLISH A QUALITY STANDARD FOR CONTRACTOR; EXCEPT THAT ELITE MAY PROVIDE PLANS AND SPECIFICATIONS FOR AN ASSIGNMENT BUT ELITE CANNOT OVERSEE THE ACTUAL ASSIGNMENT OR INSTRUCT CONTRACTOR AS TO HOW THE ASSIGNMENT WILL BE PERFORMED;","style":["para","dark"]},{"text":"ELITE DOES NOT PAY A SALARY OR HOURLY RATE BUT RATHER A FIXED OR CONTRACT RATE FOR AN ASSIGNMENT;","style":["para","dark"]},{"text":"ELITE CANNOT TERMINATE AN ASSIGNMENT DURING THE ASSIGNMENT UNLESS CONTRACTOR VIOLATES THE TERMS OF THE ASSIGNMENT OR THIS AGREEMENT OR FAILS TO PRODUCE A RESULT THAT MEETS THE SPECIFICATIONS OF THE ASSIGNMENT;","style":["para","dark"]},{"text":"ELITE DOES NOT PROVIDE ANYTHING MORE THAN MINIMAL TRAINING FOR CONTRACTOR;","style":["para","dark"]},{"text":"ELITE DOES NOT PROVIDE TOOLS OR BENEFITS TO CONTRACTOR; EXCEPT THAT MATERIALS AND EQUIPMENT MAY BE SUPPLIED;","style":["para","dark"]},{"text":"ELITE DOES NOT DICTATE THE TIME OF PERFORMANCE OF AN ASSIGNMENT; EXCEPT THAT A COMPLETION SCHEDULE AND A RANGE OF MUTUALLY AGREEABLE WORK HOURS MAY BE ESTABLISHED;","style":["para","dark"]},{"text":"IF CONTRACTOR IS AN INDIVIDUAL, ELITE DOES NOT PAY CONTRACTOR PERSONALLY BUT RATHER MAKES CHECKS PAYABLE TO THE TRADE OR BUSINESS NAME OF CONTRACTOR.","style":["para","dark"]},{"text":"ELITE DOES NOT COMBINE ITS BUSINESS OPERATIONS IN ANY WAY WITH CONTRACTOR'S BUSINESS, BUT INSTEAD MAINTAINS SUCH OPERATIONS AS SEPARATE AND DISTINCT.","style":["para","dark"]},{"text":"Section V:  Subcontractors and Employees of Contractor\\n","style":"section"},{"text":"Contractor may use sub-contractors or employees. Contractor shall be solely responsible for the supervision of its employees and contractors and the payment of compensation, wages, workers compensation insurance, unemployment insurance, taxes, and similar matters related to Contractor’s owners, employees, and contractors. Contractor shall save and hold Elite harmless from any claims or demands arising related to the relationship between Contractor and its employees and contractors including, but not limited to: i) claims by Contractor’s owners, employees, or contractors for damages, injuries, losses, payments, salaries, taxes, benefits, or other matters; and, ii) claims by any third parties, including, but not limited to, Clients, unrelated parties, and governmental agencies, for damages, injuries, or losses of any kind related to an Assignment.\\n\\n","style":"para"},{"text":"Section VI:  Relationship Between Parties\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Independent Contractor.  ","bold":true,"italics":true},"Contractor is engaged in an independent business and customarily has performed or does perform services for businesses other than Elite.  Contractor will perform Assignments as an independent contractor and not as an agent, partner, venturer, or employee of Elite."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Training.  ","bold":true,"italics":true},"Elite shall not provide Contractor with any training or continuing education. The cost of any training or continuing education required to perform the Assignment shall be provided and paid by Contractor."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Authority.  ","bold":true,"italics":true},"Contractor does not have the authority to act for or bind Elite in any respect or to incur any debts or liabilities in the name, or on behalf, of Elite."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Coordination.  ","bold":true,"italics":true},"Elite shall not control, oversee, or supervise Contractor in any way in the fulfillment of an Assignment, or control the manner in which Contractor fulfills the Assignment. However, Elite shall be available for consultation, coordination, assistance, coverage issues, and/or advice."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"No Guaranty of Assignments.  ","bold":true,"italics":true},"Elite does not guarantee Assignments to Contractor. Contractor waives any claim against Elite for dependency upon Assignments and shall release, indemnify, and hold Elite harmless from any claims and liabilities relating to Contractor’s financial stability, which may result in a lack of Assignments."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Workers Compensation Insurance.  ","bold":true,"italics":true},"Contractor shall provide Elite with proof, or a waiver, of workers compensation insurance for all owners, employees, or contractors of Contractor in accordance with all applicable laws, prior to commencing any Assignment and thereafter upon request of Elite. All such insurance shall be paid by Contractor. If Contractor does not maintain workers’ compensation insurance as required by law, Elite may recover from Contractor all costs that it sustains in providing workers’ compensation insurance for Contractor’s employees and contractors."],"style":"para"},{"text":[{"text":"G.    ","style":"bullet"},{"text":"Business Cards.  ","bold":true,"italics":true},"Contractor may use business cards setting forth Contractor’s name and contact information. Contractor shall not reflect any business relationship with Elite on any business cards, invoices, statements, or, advertisements except for stating that Elite is one of its customers.\\n\\n"],"style":"para"},{"text":"Section VII:  Conduct and Performance\\n","style":"section","xpageBreak":"before"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Quality.  ","bold":true,"italics":true},"Contractor shall use its best efforts to complete all Assignments in accordance with the specifications of Assignment."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Identification.  ","bold":true,"italics":true},"While fulfilling an Assignment, Contractor shall furnish and maintain, at its own cost and expense, identification as required by Client (e.g. an identification badge)."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Workplace.  ","bold":true,"italics":true},"Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Equipment.  ","bold":true,"italics":true},"Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Vehicle.  ","bold":true,"italics":true},"Contractor shall provide a vehicle sufficient to perform an Assignment and in relation to such vehicle, Contractor shall:"],"style":"para"},{"text":[{"text":"i)  ","style":"bullet"},{"text":"Vehicle Size","bold":true,"decoration":"underline"},".  Not use a vehicle for an Assignment with a Gross Vehicle weight in excess of 10,000 pounds."],"margin":[20,0,0,6]},{"text":[{"text":"ii)  ","style":"bullet"},{"text":"Expenses","bold":true,"decoration":"underline"},".  Pay for all costs and expenses associated with such vehicle, including, but not limited to: a) the purchase of the vehicle in Contractor’s business name; b) registration fees; c) license fees; d) inspection fees; d) fines; f) maintenance and repairs; g) personal property taxes; g) sales and use taxes; and h) fuel, oil, fluids, tires, and other replacement parts."],"margin":[20,0,0,6]},{"text":[{"text":"iii)  ","style":"bullet"},{"text":"Insurance","bold":true,"decoration":"underline"},".  Contractor shall provide Elite proof of, and shall maintain at Contractor’s sole cost and expense, insurance in accordance with the following:"],"margin":[20,0,0,6]},{"text":[{"text":"a)  ","style":"bullet"},"Vehicle Insurance: For each vehicle used by Contractor pursuant to an Assignment, Contractor shall maintain insurance coverage with $100,000/$300,000/$500,000 of coverage."],"margin":[40,0,0,6]},{"text":[{"text":"b)  ","style":"bullet"},"Liability Insurance: Contractor shall maintain general liability insurance with a single combined liability limit of not less than one million dollars ($1,000,000.00) insuring against all liability of Contractor and its authorized representatives in connection with an Assignment"],"margin":[40,0,0,6]},{"text":[{"text":"c)  ","style":"bullet"},"Additional Insureds: The above insurance policies shall name Elite as an additional insured and shall provide that the policies may not be changed, non-renewed, terminated, or canceled unless the insurance carrier provides at least thirty (30) days prior written notice of the aforesaid to Elite."],"margin":[40,0,0,6]},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Laws.  ","bold":true,"italics":true},"Contractor shall comply with all federal, state, municipal, county, or other governmental or quasigovernmental requirements, laws, ordinances, regulations, and rules in the performance of an Assignment."],"style":"para"},{"text":[{"text":"G.    ","style":"bullet"},{"text":"Representations.  ","bold":true,"italics":true},"Contractor shall commit no deceptive, misleading, or unethical acts in fulfilling an Assignment and shall make no representations, warranties, or guarantees on behalf of Elite."],"style":"para"},{"text":"Section VIII:  Payment\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Profits/Losses.  ","bold":true,"italics":true},"Contractor shall be entitled to all profits it earns and losses it incurs related to an Assignment."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Invoices.  ","bold":true,"italics":true},"Contractor shall periodically invoice Elite for Assignments and, at the request of Elite, shall provide backup documentation for the matters claimed in invoices."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Payments.  ","bold":true,"italics":true},"Contractor shall be paid for an Assignment pursuant to the Schedule set forth in Exhibit A as may be modified from time-to-time regardless of the number of hours expended by Contractor. Payment shall be made within 15 business days of receipt by Elite of a complying invoice and Contractor providing any backup documentation requested by Elite."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Trade or Business Name.  ","bold":true,"italics":true},"All payments shall be payable to Contractor’s trade or business name."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Taxes.  ","bold":true,"italics":true},"Contractor shall withhold, contribute, and pay all applicable FICA, federal, state, and local income taxes or assessments for or on behalf of its employees. Elite shall provide Contractor a 1099 tax form after each calendar year in accordance with applicable laws."],"style":"para"},{"text":"Section IX:  Indemnification\\n","style":"section","xpageBreak":"before"},"Contractor shall save and hold Elite, its owners, affiliates, agents, directors, officers, contractors, and employees harmless from any claims, liabilities, costs, or damages incurred as a result of:\\n\\n",{"text":[{"text":"A.    ","style":"bullet"},{"text":"Taxes.  ","bold":true,"italics":true},"Taxes due for any payment made by Elite to Contractor."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Employees and Contractors.  ","bold":true,"italics":true},"Payments due for services, including taxes due thereon, made to Contractor’s owners, employees, and contractors."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Debts.  ","bold":true,"italics":true},"Any debts, taxes, or liabilities of Contractor."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Acts.  ","bold":true,"italics":true},"Tortuous or contractual acts of Contractor whether or not related to the Assignment."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Consequential Liability.  ","bold":true,"italics":true},"Liabilities and damages caused to third parties by Contractor."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Workers Compensation.  ","bold":true,"italics":true},"Worker’s compensation insurance premiums paid by Elite for Contractors employees or contractors."],"style":"para"},{"text":"In the event of any claim set forth above against Elite, Contractor shall reimburse Elite for all costs of defense (including but not limited to attorney’s fees, costs, and expenses whether or not suit is actually filed) within 30 days of Elite forwarding an invoice to Contractor for such fees, costs, expenses or damages.","margin":[0,0,0,10]},{"text":"Section X:  Termination\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Without Cause.  ","bold":true,"italics":true},"Either Party may terminate this Agreement at any time without notice and without cause in which case Contractor shall not thereafter by offered Assignments. Notwithstanding the aforesaid, this Agreement shall not be terminated during an Assignment unless Contractor violates the terms of an Assignment or fails to meet the specifications of an Assignment."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Payment Upon Termination.  ","bold":true,"italics":true},"Each Party will pay all amounts due to the other Party upon the termination of this Agreement and shall pay any future amounts due to the other Party as they become due. Elite may apply any setoffs it may have against Contractor towards any payment due to Contractor."],"style":"para"},{"text":"Section XI:  Confidential Information\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Confidential Information.  ","bold":true,"italics":true},"“Confidential Information” shall mean any business information, including Client information obtained in connection with this Agreement, in a tangible form which is marked as confidential or proprietary, otherwise learned, or which is known, or should be known, to be confidential."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"No Confidential Information to Elite.  ","bold":true,"italics":true},"Elite does not wish to receive Confidential Information from Contractor."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Terms of Non-Disclosure.  ","bold":true,"italics":true},"Contractor shall not disclose, use, or copy Confidential Information of Elite during the term of this Agreement (except in furtherance of an Assignment) and for a period of two (2) years thereafter other than in the fulfillment of an Assignment unless specifically authorized to do so in writing by Elite which authorization may be withheld by Elite for any reason or no reason. Contractor shall exercise of at least the same degree of care used to protect its own information of like importance but not less than a reasonable degree of care."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Client.  ","bold":true,"italics":true},"Contractor shall be subject to the Colorado Trade Secrets Act in all of its dealings with Clients."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"On Site Information.  ","bold":true,"italics":true},"The nature of an Assignment may require Contractor to be present at the site of Elite or a Client where Contractor may hear or learn of Confidential Information and Contractor may be required to access information on computers of Elite all of which shall be deemed Confidential Information subject to the restrictions set forth herein."],"style":"para"},{"text":"Section XII:  Non-Solicitation of Elite Employees and Contractors\\n","style":"section"},"Contractor shall not, on its own behalf or on behalf of any third party recruit, solicit, or hire employees or other independent contractors of Elite employed or under contract with Elite during the period of this Agreement or for a period of two (2) years after termination of this Agreement. In the event of a violation of the terms herein, damages will be difficult to ascertain but will nevertheless be real and substantial and as a result thereof, Elite shall be entitled to liquidated damages equal to the average monthly salary or contract payments times six (6) made by Elite to the employee or independent contractor later hired by, or contracting with, Contractor or a third party as a result of the acts of Contractor. Said liquidated damages are fair and reasonable under these circumstances. In addition, such solicitation or hiring will cause immediate and irreparable injury to Elite and as a result thereof, Elite shall be entitled to injunctive relief without bond. For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action with Elite as related to their employment by, or contract with, Elite.\\n\\n",{"text":"Section XIII: Non-Circumvention and Non-Solicitation of Clients\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Prohibitions.  ","bold":true,"italics":true},"Due to the amount and sensitivity of Confidential Information that will be provided to Contractor, or to which it may have access including, but not limited to, marketing plans, Client billing history, or Elite business operations, and other financial data of Elite. Contractor shall not, on its own behalf or on behalf of any third party, solicit business from any Client using Confidential Information during the term of the Agreement and for a period of one (1) year thereafter."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Solicit.  ","bold":true,"italics":true},"For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action which is materially based on or considers Confidential Information."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Damages.  ","bold":true,"italics":true},"In the event of a violation of the Prohibitions stated above, damages will be difficult to determine, but will, nevertheless, be real and substantial and therefore the Parties agree to liquidated damages in an amount equal to the greater of: i) 150% of the average monthly billing by Elite of that Client times 12 during the preceding 12 month period (measured from the date of discovery of the initial violation) or ii) 66 2/3% of the gross amount of the first year’s fees billed to that Client by Contractor on its own behalf or a third party with whom Contractor is or has been associated in the aforesaid solicitation. Such liquidated damages are fair and reasonable under these circumstances."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Injunctive Relief.  ","bold":true,"italics":true},"Notwithstanding the right of Elite to liquidated damages and actual damages, a violation of the prohibitions herein will cause Elite immediate and irreparable injury and as a result thereof, Elite shall be entitled to injunctive relief without bond."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Notice.  ","bold":true,"italics":true},"Elite shall be entitled to provide notice of this Agreement to any Clients at any time without any liability to Contractor for such disclosure."],"style":"para"},{"text":"Section XIV:  Non-Disparagement\\n","style":"section"},"Contractor shall not disparage Elite, or any of its affiliated companies, employees, officers, agents or contractors or otherwise act in a fashion designed to injure the business of Elite. This provision will not apply to truthful comments in response to a lawful subpoena or other legal process. In the event of a violation of this Section, the Parties agree that damages will difficult to determine, but are nevertheless real and substantial and therefore agree to liquidated damages in the amount equal to $5,000 for each incident of disparagement. Continuous statements made on separate dates, or if on the same date to separate people, shall be considered separate incidents each resulting in liquidated damages in the aforesaid amount. Such liquidated damages are fair and reasonable.\\n\\n",{"text":"Section XV:  Disputes, Jurisdiction, Mediation\\n","style":"section"},"In the event of a dispute regarding this Agreement or the relationship or business dealings between the Parties, the following shall apply:\\n\\n",{"text":[{"text":"A.    ","style":"bullet"},{"text":"Negotiations/Mediation.  ","bold":true,"italics":true},"The Parties shall first attempt in good faith to resolve any dispute through private negotiations. If the dispute is not resolved within 30-days of the first written notice of the dispute, the dispute shall be submitted for mediation in the City and County of Denver or the County of Arapahoe, Colorado to the Judicial Arbitration and Mediation Service (“JAMS”), or another mutually agreeable mediator, in accordance with the Mediation Rules of JAMS."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Mandatory Arbitration.  ","bold":true,"italics":true},"Any dispute not resolved by mediation as set forth above will be submitted for mandatory arbitration in the City and County of Denver or the County of Arapahoe, Colorado to JAMS, or another mutually agreeable arbitrator. All disputes shall be arbitrated in accordance with the Comprehensive Rules of Arbitration of JAMS. The Parties adopt the Optional Appeals Procedures of JAMS. All costs of arbitration shall be shared equally between the Parties."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Award.  ","bold":true,"italics":true},"The Final Award issued by the arbitrator shall not include comprehensive findings of fact and conclusions of law. Judgment upon the Final Award may be entered in any Colorado Court that has jurisdiction."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Jury Trial.  ","bold":true,"italics":true},"THE PARTIES WAIVE ANY RIGHT TO A TRIAL BY JURY OR BY A JUDGE."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Attorneys’ Fees.  ","bold":true,"italics":true},"In the event of any arbitration or litigation between the Parties related to this Agreement, the prevailing Party shall be entitled to recover its reasonable attorneys’ fees."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Damage Limitations.  ","bold":true,"italics":true},"Elite will not be liable to Contractor for any incidental, indirect, special, or consequential damages of any kind including, but not limited to, any loss of business, loss of income, or loss of profit, even if advised of the possibility of such damage or if such damage could have been reasonably foreseen. In the event of any claim by Contractor against Elite, Contractor’s remedies shall be solely limited to the assets of Elite. No officer, director, employee, or agent of Elite shall have any personal liability to Contractor for any claim of Contractor arising out of this Agreement or the relationship between Elite and Contractor. If any such claim exists in law or equity against an officer, director, or other employee or independent contractor of Elite, Contractor waives such claim."],"style":"para"},{"text":"Section XVI:  Miscellaneous\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Execution.  ","bold":true,"italics":true},"This Agreement may be executed in one or more counterparts, each of which shall constitute one and the same instrument. Execution may be by electronic signature wherein delivery shall be deemed completed by e-mail if there is electronic confirmation of receipt and opening of the e-mail by the recipient or by facsimile transmission with confirmation of delivery to the recipient."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Complete Agreement.  ","bold":true,"italics":true},"This Agreement contains a complete Agreement concerning the contractual relationship between Contractor and  Elite and shall supersede all agreements between the Parties. Contractor acknowledges that Elite has made no further representation regarding the terms of this relationship."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Assignment.  ","bold":true,"italics":true},"Contractor shall not have the right to assign this Agreement."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Savings Clause and Severability.  ","bold":true,"italics":true},"If in any action before any Court or tribunal empowered to enforce the terms and conditions herein, any portion or section of this Agreement is found to be unenforceable, illegal, or unlawful for any reason, then such term, restriction, remedy, portion, section, or covenant shall be deemed modified to the extent necessary to make it enforceable. In the event that any of the terms and conditions herein are declared invalid, unenforceable, or void for any reason whatsoever, the remaining terms and conditions shall be in full force and effect and binding upon the Parties herein as if the invalid, unenforceable, or void terms were not made a part hereof."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Waiver.  ","bold":true,"italics":true},"The failure of either Party to exercise any right shall not be construed to be a waiver unless agreed upon in writing. A waiver in any one instance will not constitute an amendment to this Agreement or indicate any continued waivers of such right on any other occasion."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Survival.  ","bold":true,"italics":true},"The provisions of this Agreement that by their nature continue after termination will survive the expiration, termination, or cancellation of this Agreement including, but not limited to, §§IX-XV."],"style":"para"},{"text":[{"text":"G.    ","style":"bullet"},{"text":"Modifications.  ","bold":true,"italics":true},"No waiver or modification of this Agreement or any covenants herein shall be valid unless made in writing and duly executed by both Parties. No evidence of any waiver or modification shall be offered or received into evidence or any proceeding for arbitration or litigation between the Parties unless such waiver or modification is in writing, duly executed by both Parties."],"style":"para"},{"text":[{"text":"H.    ","style":"bullet"},{"text":"Attorneys' Fees.  ","bold":true,"italics":true},"In the event any Party violates any of the terms herein, the defaulting Party shall be liable for the reasonable attorney's fees of the non-defaulting Party incurred as a result of enforcing the terms herein whether or not litigation, mediation, or arbitration is commenced."],"style":"para"},{"text":[{"text":"I.    ","style":"bullet"},{"text":"Law.  ","bold":true,"italics":true},"This Agreement shall be governed and controlled by the laws of Colorado and the sole jurisdiction and the venue for hearing any matters arising out of, or related to, this Agreement shall be in City and County of Denver, Colorado."],"style":"para"},{"text":[{"text":"J.    ","style":"bullet"},{"text":"Assignability.  ","bold":true,"italics":true},"This Agreement shall inure to the benefit of, and shall be binding on, Elite and any entity with which Elite may merge or assign its rights and duties under this Agreement."],"style":"para"},{"text":[{"text":"K.    ","style":"bullet"},{"text":"Notices.  ","bold":true,"italics":true},"Any notice required herein shall be effective three days after mailing Certified Mail, in the U.S. Mail, postage prepaid or upon actual receipt if hand-delivered or forwarded by overnight carrier. A notice transmitted and delivered by fax or e-mail or other electronic means shall be effective if there is proof of delivery in which case the effective date shall be the date of delivery. Notice shall be made to the addresses set forth above."],"style":"para"},{"text":[{"text":"L.    ","style":"bullet"},{"text":"Time is of the Essence.  ","bold":true,"italics":true},"Time is of the essence in the performance of any duty or requirement in this Agreement and a significant and material term of this Agreement."],"style":"para"},{"text":[{"text":"M.    ","style":"bullet"},{"text":"Negotiated.  ","bold":true,"italics":true},"The Parties have independently, separately, and freely negotiated each provision of this Contract as if all Parties drafted this Contract. The Parties, therefore, waive any statutory or common-law presumption that would serve to have this document construed in favor of, or against, either Party."],"style":"para"},{"text":[{"text":"N.    ","style":"bullet"},{"text":"Headings.  ","bold":true,"italics":true},"The headings of the Articles herein are inserted for convenience only and are not intended to affect the meaning or interpretation of this Agreement."],"margin":[0,0,0,20]},{"text":"BY OUR SIGNATURES WE AGREE TO THE ABOVE TERMS.","bold":true,"margin":[0,0,0,20]},{"text":[{"text":"Contractor:\\t\\t\\t","bold":true},{"text":"{{{userName}}}"},"\\n\\n\\n"]},{"text":[{"text":"DBA:\\t\\t\\t\\t\\t\\t","bold":true},{"text":"{{{companyName}}}"},"\\n\\n\\n"]},{"text":[{"text":"Date:\\t\\t\\t\\t\\t\\t","bold":true},{"text":"{{{date}}}"},"\\n\\n\\n"]},{"text":"Signature:","bold":true},{"canvas":[{"type":"line","x1":75,"y1":0,"x2":210,"y2":0,"lineWidth":1}]},{"image":"{{{signature}}}","fit":[90,250],"margin":[85,-20,0,0]},{"text":["Elite Logistics, Inc.\\n\\n"],"bold":true,"margin":[0,100,0,0]},{"text":[{"text":"Date:\\t\\t\\t\\t\\t\\t","bold":true},{"text":"{{{date}}}"},"\\n\\n\\n"]},{"text":"Signature:","bold":true},{"canvas":[{"type":"line","x1":75,"y1":0,"x2":210,"y2":0,"lineWidth":1}]},{"image":"{{{brentSig}}}","fit":[90,250],"margin":[85,-20,0,0]},{"text":"By: Brent LaFave, President","margin":[75,3,0,0],"pageBreak":"after"},{"text":"Exhibit A\\nPayment Schedule","alignment":"center","bold":true,"fontSize":12,"margin":[0,0,0,20]},{"ol":[{"text":"Contractor shall be compensated at a rate commensurate with the vehicle type used to complete each Assignment, as set out in the Compensation Rate Per Vehicle table below. Notwithstanding the aforesaid, at no time shall Contractor be paid for days or partial days that Contractor spends fulfilling an Assignment that are in excess of a reasonable time necessary to fulfill the Assignment as determined by Elite in its sole discretion. In the event that Contractor is unable or unwilling to complete an Assignment, the compensation shall be adjusted by Elite, taking into consideration the amount of the Assignment completed by Contractor and the damages caused to Elite as a result of the intentional or negligent acts of Contractor.","margin":[0,0,0,8]},{"text":"Contractor shall be compensated for special deliveries (generally deliveries that will take less than 4 hours) and fuel at rates established between Elite and Contractor prior to commencing the delivery.","margin":[0,0,0,8]},{"text":"Elite shall partially reimburse Contractor for fuel used by Contractor in fulfilling an Assignment at a rate determined by a sliding scale, as illustrated by the example fuel reimbursement table below. The rate may vary from Assignment to Assignment based on the agreement between Elite and its customer. The reimbursement is based on a fuel price of $3.00/gallon (see the example fuel reimbursement table below) for regular unleaded gas, an estimated average miles per gallon for delivery vehicles used by contractors of Elite, and an average number of miles per Assignment of Elite contractors. The reimbursement may, but need not, be adjusted up or down by Elite, in its sole discretion, with the price of regular unleaded gas established by the most recent “Fuel Gauge Report” of the American Automobile Association and further based upon fuel charges by Elite to Client. Current reimbursement values can be found in the Fuel tab of the Elite Logistics Driver application.","margin":[0,0,0,8]}]},{"text":"Compensation Rate Per Vehicle:","fontSize":12,"bold":true,"margin":[0,20,0,8]},{"style":"tableExample","table":{"alignment":"left","headerRows":1,"body":[[{"text":"Vehicle","style":"tableHeader"},{"text":"Compensation","style":"tableHeader"}],{{{invite_vehicles}}}]},"layout":"headerLineOnly"},{"text":[{"text":"Compensation Notes:\\t","bold":true},{"text":"{{{invite_payNotes}}}"},"\\n\\n\\n"]},{"text":"Fuel Reimbursement Table (Sample):","fontSize":12,"bold":true,"margin":[0,0,0,8]},{"style":"tableExample","table":{"headerRows":1,"body":[[{"text":"Fuel Price Range","style":"tableHeader"},{"text":"Per Completed Assignment","style":"tableHeader"}],["$3.01 - $3.10","$6.36"],["$3.11 - $3.20","$7.45"],["$3.21 - $3.30","$8.67"],["$3.31 - $3.40","$9.89"],["$3.41 - $3.50","$11.11"],["$3.51 - $3.60","$12.33"],["$3.61 - $3.70","$13.55"],["$3.71 - $3.80","$14.77"],["$3.81 - $3.90","$15.99"],["$3.91 - $4.00","$17.21"]]},"layout":"headerLineOnly"}],"defaultStyle":{"fontSize":9.5,"bold":false,"columnGap":125},"styles":{"listitem":{"italics":true,"margin":[0,0,0,9]},"label":{"bold":true},"link":{"color":"#333","fontSize":8},"para":{"margin":[0,0,0,8]},"section":{"bold":true,"margin":[0,2,0,4]},"dark":{"bold":true},"bullet":{"margin":[0,0,10,0]},"header":{"fontSize":18,"bold":true,"margin":[0,0,0,10]},"tableExample":{"margin":[0,5,0,15],"alignment":"center"},"tableHeader":{"bold":true,"fontSize":10,"color":"black"}},"images":{"logo":"data:image/png;base64,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"}}`

        //
        //  A compilation note:  the "{{{invite_vehicles}}}" tag must be surrounded by double quotes in order to
        //  load it as a json string in the JSON viewer (where is can be formatted and compressed.)  After it
        //  is compressed and added to the this.json variable above, remove the double quotes, or the vehicles
        //  list will not display correctly, and json.parse will fail with an "invalid character at" error.
        //
        /*
        this.formatted = `
{
  "pageSize": "LETTER",
  "pageMargins": [
    72,
    45,
    72,
    45
  ],
  "content": [
    {
      "image": "logo",
      "width": 120,
      "alignment": "center",
      "margin": [
        0,
        0,
        0,
        14
      ]
    },
    {
      "text": "Independent Contractor Master Agreement",
      "alignment": "center",
      "bold": true,
      "fontSize": 12,
      "margin": [
        0,
        0,
        0,
        14
      ]
    },
    {
      "text": "Between",
      "alignment": "center",
      "bold": true,
      "fontSize": 10,
      "margin": [
        0,
        0,
        0,
        14
      ]
    },
    {
      "columns": [
        {
          "text": [
            "Elite Logistics, Inc\\n",
            "Attn: Brent LaFave\\n",
            "P.O. Box 630122\\n",
            "Littleton, CO  80163-0122\\n",
            "Telephone: 303.994.9633"
          ]
        },
        {
          "text": [
            "Contractor:  {{{userName}}}\\n\\n",
            "DBA:  {{{companyName}}}\\n\\n",
            "Telephone:  {{{phone}}}"
          ],
          "alignment": "right"
        }
      ],
      "margin": [
        0,
        0,
        0,
        16
      ]
    },
    {
      "text": [
        {
          "text": "THIS AGREEMENT ",
          "bold": true
        },
        "is between Elite Logistics, Inc. (",
        {
          "text": "¨Elite¨",
          "bold": true
        },
        ") and the above named party (",
        {
          "text": "¨Contractor¨",
          "bold": true
        },
        ") [Individually a “Party” and collectively the “Parties”] effective this {{{invite_dayOrdinal(edate)}}} day of {{{invite_month(edate)}}}, {{{invite_year(edate)}}} (the ",
        {
          "text": "¨Effective Date¨",
          "bold": true
        },
        ")."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "WHEREAS",
          "bold": true
        },
        ", Elite provides logistic support to businesses (",
        {
          "text": "“Client[s]”",
          "bold": true
        },
        {
          "text": ") through independent contractors who use their own rolling equipment, supplies, materials, tools and who provide their own fuel, maintenance, and insurance related to the aforesaid; and\\n\\n"
        },
        {
          "text": "WHEREAS",
          "bold": true
        },
        ", Contractor is a business separate and apart from Elite with no overlapping ownership or control; and is customarily engaged in a business related to the service to be performed under this Agreement; and,\\n\\n",
        {
          "text": "WHEREAS",
          "bold": true
        },
        ", Contractor provides workers compensation insurance and unemployment insurance for its employees.\\n\\n",
        {
          "text": "NOW THEREFORE",
          "bold": true
        },
        ", in consideration of the covenants and restrictions herein, the Parties agree:\\n"
      ],
      "style": "para"
    },
    {
      "text": "Section I:  Assignments\\n",
      "style": "section"
    },
    {
      "text": "Elite may present opportunities to Contractor to provide delivery services for Clients (an ¨Assignment¨) setting forth the Client's requirements and needs including the dates and times needed and delivery destination(s) where known.  Contractor shall have the option to accept or reject the Assignment with Clients; however, all Assignments shall be subject to approval of Contractor by the Client.  An assignment will be delivery, or other service, that takes one day or less to complete unless stated otherwise.  An Assignment will not include special deliveries or similar services (generally services that will take four hours or less to complete).",
      "style": "para"
    },
    {
      "text": "Section II:  Subcontract\\n",
      "style": "section"
    },
    {
      "text": "Contractor may fulfill any Assignment by use of its employees or may subcontract an Assignment to a third party.",
      "style": "para"
    },
    {
      "text": "Section III:  Term\\n",
      "style": "section"
    },
    {
      "text": "The term of this Agreement shall commence on the Effective Date and shall be applicable to all Assignments.  Notwithstanding the aforesaid, Elite does not guaranty Contractor any Assignment or reassignment of Contractor to a Client after any Assignment.",
      "style": "para"
    },
    {
      "text": "Section IV:  Disclaimers\\n",
      "style": "section"
    },
    {
      "text": "CONTRACTOR IS NOT ENTITLED TO UNEMPLOYMENT COMPENSATION INSURANCE BENEFITS UNLESS UNEMPLOYMENT COMPENSATION INSURANCE COVERAGE IS PROVIDED BY CONTRACTOR OR SOME OTHER ENTITY;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "CONTRACTOR IS OBLIGATED TO PAY FEDERAL AND STATE INCOME TAX ON ANY MONEYS PAID PURSUANT TO THE CONTRACT RELATIONSHIP;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "CONTRACTOR IS NOT REQUIRED TO ACCEPT AN ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "CONTRACTOR IS NOT REQUIRED TO WORK EXCLUSIVELY FOR ELITE, EXCEPT THAT CONTRACTOR MAY CHOOSE TO WORK EXCLUSIVELY FOR A FINITE PERIOD OF TIME SPECIFIED IN THIS AGREEMENT OR IN AN ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT ESTABLISH A QUALITY STANDARD FOR CONTRACTOR; EXCEPT THAT ELITE MAY PROVIDE PLANS AND SPECIFICATIONS FOR AN ASSIGNMENT BUT ELITE CANNOT OVERSEE THE ACTUAL ASSIGNMENT OR INSTRUCT CONTRACTOR AS TO HOW THE ASSIGNMENT WILL BE PERFORMED;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT PAY A SALARY OR HOURLY RATE BUT RATHER A FIXED OR CONTRACT RATE FOR AN ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE CANNOT TERMINATE AN ASSIGNMENT DURING THE ASSIGNMENT UNLESS CONTRACTOR VIOLATES THE TERMS OF THE ASSIGNMENT OR THIS AGREEMENT OR FAILS TO PRODUCE A RESULT THAT MEETS THE SPECIFICATIONS OF THE ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT PROVIDE ANYTHING MORE THAN MINIMAL TRAINING FOR CONTRACTOR;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT PROVIDE TOOLS OR BENEFITS TO CONTRACTOR; EXCEPT THAT MATERIALS AND EQUIPMENT MAY BE SUPPLIED;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT DICTATE THE TIME OF PERFORMANCE OF AN ASSIGNMENT; EXCEPT THAT A COMPLETION SCHEDULE AND A RANGE OF MUTUALLY AGREEABLE WORK HOURS MAY BE ESTABLISHED;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "IF CONTRACTOR IS AN INDIVIDUAL, ELITE DOES NOT PAY CONTRACTOR PERSONALLY BUT RATHER MAKES CHECKS PAYABLE TO THE TRADE OR BUSINESS NAME OF CONTRACTOR.",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT COMBINE ITS BUSINESS OPERATIONS IN ANY WAY WITH CONTRACTOR'S BUSINESS, BUT INSTEAD MAINTAINS SUCH OPERATIONS AS SEPARATE AND DISTINCT.",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "Section V:  Subcontractors and Employees of Contractor\\n",
      "style": "section"
    },
    {
      "text": "Contractor may use sub-contractors or employees. Contractor shall be solely responsible for the supervision of its employees and contractors and the payment of compensation, wages, workers compensation insurance, unemployment insurance, taxes, and similar matters related to Contractor’s owners, employees, and contractors. Contractor shall save and hold Elite harmless from any claims or demands arising related to the relationship between Contractor and its employees and contractors including, but not limited to: i) claims by Contractor’s owners, employees, or contractors for damages, injuries, losses, payments, salaries, taxes, benefits, or other matters; and, ii) claims by any third parties, including, but not limited to, Clients, unrelated parties, and governmental agencies, for damages, injuries, or losses of any kind related to an Assignment.\\n\\n",
      "style": "para"
    },
    {
      "text": "Section VI:  Relationship Between Parties\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Independent Contractor.  ",
          "bold": true,
          "italics": true
        },
        "Contractor is engaged in an independent business and customarily has performed or does perform services for businesses other than Elite.  Contractor will perform Assignments as an independent contractor and not as an agent, partner, venturer, or employee of Elite."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Training.  ",
          "bold": true,
          "italics": true
        },
        "Elite shall not provide Contractor with any training or continuing education. The cost of any training or continuing education required to perform the Assignment shall be provided and paid by Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Authority.  ",
          "bold": true,
          "italics": true
        },
        "Contractor does not have the authority to act for or bind Elite in any respect or to incur any debts or liabilities in the name, or on behalf, of Elite."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Coordination.  ",
          "bold": true,
          "italics": true
        },
        "Elite shall not control, oversee, or supervise Contractor in any way in the fulfillment of an Assignment, or control the manner in which Contractor fulfills the Assignment. However, Elite shall be available for consultation, coordination, assistance, coverage issues, and/or advice."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "No Guaranty of Assignments.  ",
          "bold": true,
          "italics": true
        },
        "Elite does not guarantee Assignments to Contractor. Contractor waives any claim against Elite for dependency upon Assignments and shall release, indemnify, and hold Elite harmless from any claims and liabilities relating to Contractor’s financial stability, which may result in a lack of Assignments."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Workers Compensation Insurance.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide Elite with proof, or a waiver, of workers compensation insurance for all owners, employees, or contractors of Contractor in accordance with all applicable laws, prior to commencing any Assignment and thereafter upon request of Elite. All such insurance shall be paid by Contractor. If Contractor does not maintain workers’ compensation insurance as required by law, Elite may recover from Contractor all costs that it sustains in providing workers’ compensation insurance for Contractor’s employees and contractors."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "G.    ",
          "style": "bullet"
        },
        {
          "text": "Business Cards.  ",
          "bold": true,
          "italics": true
        },
        "Contractor may use business cards setting forth Contractor’s name and contact information. Contractor shall not reflect any business relationship with Elite on any business cards, invoices, statements, or, advertisements except for stating that Elite is one of its customers.\\n\\n"
      ],
      "style": "para"
    },
    {
      "text": "Section VII:  Conduct and Performance\\n",
      "style": "section",
      "xpageBreak": "before"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Quality.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall use its best efforts to complete all Assignments in accordance with the specifications of Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Identification.  ",
          "bold": true,
          "italics": true
        },
        "While fulfilling an Assignment, Contractor shall furnish and maintain, at its own cost and expense, identification as required by Client (e.g. an identification badge)."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Workplace.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Equipment.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Vehicle.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide a vehicle sufficient to perform an Assignment and in relation to such vehicle, Contractor shall:"
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "i)  ",
          "style": "bullet"
        },
        {
          "text": "Vehicle Size",
          "bold": true,
          "decoration": "underline"
        },
        ".  Not use a vehicle for an Assignment with a Gross Vehicle weight in excess of 10,000 pounds."
      ],
      "margin": [
        20,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "ii)  ",
          "style": "bullet"
        },
        {
          "text": "Expenses",
          "bold": true,
          "decoration": "underline"
        },
        ".  Pay for all costs and expenses associated with such vehicle, including, but not limited to: a) the purchase of the vehicle in Contractor’s business name; b) registration fees; c) license fees; d) inspection fees; d) fines; f) maintenance and repairs; g) personal property taxes; g) sales and use taxes; and h) fuel, oil, fluids, tires, and other replacement parts."
      ],
      "margin": [
        20,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "iii)  ",
          "style": "bullet"
        },
        {
          "text": "Insurance",
          "bold": true,
          "decoration": "underline"
        },
        ".  Contractor shall provide Elite proof of, and shall maintain at Contractor’s sole cost and expense, insurance in accordance with the following:"
      ],
      "margin": [
        20,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "a)  ",
          "style": "bullet"
        },
        "Vehicle Insurance: For each vehicle used by Contractor pursuant to an Assignment, Contractor shall maintain insurance coverage with $100,000/$300,000/$500,000 of coverage."
      ],
      "margin": [
        40,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "b)  ",
          "style": "bullet"
        },
        "Liability Insurance: Contractor shall maintain general liability insurance with a single combined liability limit of not less than one million dollars ($1,000,000.00) insuring against all liability of Contractor and its authorized representatives in connection with an Assignment"
      ],
      "margin": [
        40,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "c)  ",
          "style": "bullet"
        },
        "Additional Insureds: The above insurance policies shall name Elite as an additional insured and shall provide that the policies may not be changed, non-renewed, terminated, or canceled unless the insurance carrier provides at least thirty (30) days prior written notice of the aforesaid to Elite."
      ],
      "margin": [
        40,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Laws.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall comply with all federal, state, municipal, county, or other governmental or quasigovernmental requirements, laws, ordinances, regulations, and rules in the performance of an Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "G.    ",
          "style": "bullet"
        },
        {
          "text": "Representations.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall commit no deceptive, misleading, or unethical acts in fulfilling an Assignment and shall make no representations, warranties, or guarantees on behalf of Elite."
      ],
      "style": "para"
    },
    {
      "text": "Section VIII:  Payment\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Profits/Losses.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall be entitled to all profits it earns and losses it incurs related to an Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Invoices.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall periodically invoice Elite for Assignments and, at the request of Elite, shall provide backup documentation for the matters claimed in invoices."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Payments.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall be paid for an Assignment pursuant to the Schedule set forth in Exhibit A as may be modified from time-to-time regardless of the number of hours expended by Contractor. Payment shall be made within 15 business days of receipt by Elite of a complying invoice and Contractor providing any backup documentation requested by Elite."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Trade or Business Name.  ",
          "bold": true,
          "italics": true
        },
        "All payments shall be payable to Contractor’s trade or business name."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Taxes.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall withhold, contribute, and pay all applicable FICA, federal, state, and local income taxes or assessments for or on behalf of its employees. Elite shall provide Contractor a 1099 tax form after each calendar year in accordance with applicable laws."
      ],
      "style": "para"
    },
    {
      "text": "Section IX:  Indemnification\\n",
      "style": "section",
      "xpageBreak": "before"
    },
    "Contractor shall save and hold Elite, its owners, affiliates, agents, directors, officers, contractors, and employees harmless from any claims, liabilities, costs, or damages incurred as a result of:\\n\\n",
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Taxes.  ",
          "bold": true,
          "italics": true
        },
        "Taxes due for any payment made by Elite to Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Employees and Contractors.  ",
          "bold": true,
          "italics": true
        },
        "Payments due for services, including taxes due thereon, made to Contractor’s owners, employees, and contractors."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Debts.  ",
          "bold": true,
          "italics": true
        },
        "Any debts, taxes, or liabilities of Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Acts.  ",
          "bold": true,
          "italics": true
        },
        "Tortuous or contractual acts of Contractor whether or not related to the Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Consequential Liability.  ",
          "bold": true,
          "italics": true
        },
        "Liabilities and damages caused to third parties by Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Workers Compensation.  ",
          "bold": true,
          "italics": true
        },
        "Worker’s compensation insurance premiums paid by Elite for Contractors employees or contractors."
      ],
      "style": "para"
    },
    {
      "text": "In the event of any claim set forth above against Elite, Contractor shall reimburse Elite for all costs of defense (including but not limited to attorney’s fees, costs, and expenses whether or not suit is actually filed) within 30 days of Elite forwarding an invoice to Contractor for such fees, costs, expenses or damages.",
      "margin": [
        0,
        0,
        0,
        10
      ]
    },
    {
      "text": "Section X:  Termination\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Without Cause.  ",
          "bold": true,
          "italics": true
        },
        "Either Party may terminate this Agreement at any time without notice and without cause in which case Contractor shall not thereafter by offered Assignments. Notwithstanding the aforesaid, this Agreement shall not be terminated during an Assignment unless Contractor violates the terms of an Assignment or fails to meet the specifications of an Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Payment Upon Termination.  ",
          "bold": true,
          "italics": true
        },
        "Each Party will pay all amounts due to the other Party upon the termination of this Agreement and shall pay any future amounts due to the other Party as they become due. Elite may apply any setoffs it may have against Contractor towards any payment due to Contractor."
      ],
      "style": "para"
    },
    {
      "text": "Section XI:  Confidential Information\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Confidential Information.  ",
          "bold": true,
          "italics": true
        },
        "“Confidential Information” shall mean any business information, including Client information obtained in connection with this Agreement, in a tangible form which is marked as confidential or proprietary, otherwise learned, or which is known, or should be known, to be confidential."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "No Confidential Information to Elite.  ",
          "bold": true,
          "italics": true
        },
        "Elite does not wish to receive Confidential Information from Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Terms of Non-Disclosure.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall not disclose, use, or copy Confidential Information of Elite during the term of this Agreement (except in furtherance of an Assignment) and for a period of two (2) years thereafter other than in the fulfillment of an Assignment unless specifically authorized to do so in writing by Elite which authorization may be withheld by Elite for any reason or no reason. Contractor shall exercise of at least the same degree of care used to protect its own information of like importance but not less than a reasonable degree of care."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Client.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall be subject to the Colorado Trade Secrets Act in all of its dealings with Clients."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "On Site Information.  ",
          "bold": true,
          "italics": true
        },
        "The nature of an Assignment may require Contractor to be present at the site of Elite or a Client where Contractor may hear or learn of Confidential Information and Contractor may be required to access information on computers of Elite all of which shall be deemed Confidential Information subject to the restrictions set forth herein."
      ],
      "style": "para"
    },
    {
      "text": "Section XII:  Non-Solicitation of Elite Employees and Contractors\\n",
      "style": "section"
    },
    "Contractor shall not, on its own behalf or on behalf of any third party recruit, solicit, or hire employees or other independent contractors of Elite employed or under contract with Elite during the period of this Agreement or for a period of two (2) years after termination of this Agreement. In the event of a violation of the terms herein, damages will be difficult to ascertain but will nevertheless be real and substantial and as a result thereof, Elite shall be entitled to liquidated damages equal to the average monthly salary or contract payments times six (6) made by Elite to the employee or independent contractor later hired by, or contracting with, Contractor or a third party as a result of the acts of Contractor. Said liquidated damages are fair and reasonable under these circumstances. In addition, such solicitation or hiring will cause immediate and irreparable injury to Elite and as a result thereof, Elite shall be entitled to injunctive relief without bond. For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action with Elite as related to their employment by, or contract with, Elite.\\n\\n",
    {
      "text": "Section XIII:  Non-Circumvention and Non-Solicitation of Clients\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Prohibitions.  ",
          "bold": true,
          "italics": true
        },
        "Due to the amount and sensitivity of Confidential Information that will be provided to Contractor, or to which it may have access including, but not limited to, marketing plans, Client billing history, or Elite business operations, and other financial data of Elite. Contractor shall not, on its own behalf or on behalf of any third party, solicit business from any Client using Confidential Information during the term of the Agreement and for a period of one (1) year thereafter."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Solicit.  ",
          "bold": true,
          "italics": true
        },
        "For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action which is materially based on or considers Confidential Information."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Damages.  ",
          "bold": true,
          "italics": true
        },
        "In the event of a violation of the Prohibitions stated above, damages will be difficult to determine, but will, nevertheless, be real and substantial and therefore the Parties agree to liquidated damages in an amount equal to the greater of: i) 150% of the average monthly billing by Elite of that Client times 12 during the preceding 12 month period (measured from the date of discovery of the initial violation) or ii) 66 2/3% of the gross amount of the first year’s fees billed to that Client by Contractor on its own behalf or a third party with whom Contractor is or has been associated in the aforesaid solicitation. Such liquidated damages are fair and reasonable under these circumstances."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Injunctive Relief.  ",
          "bold": true,
          "italics": true
        },
        "Notwithstanding the right of Elite to liquidated damages and actual damages, a violation of the prohibitions herein will cause Elite immediate and irreparable injury and as a result thereof, Elite shall be entitled to injunctive relief without bond."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Notice.  ",
          "bold": true,
          "italics": true
        },
        "Elite shall be entitled to provide notice of this Agreement to any Clients at any time without any liability to Contractor for such disclosure."
      ],
      "style": "para"
    },
    {
      "text": "Section XIV:  Non-Disparagement\\n",
      "style": "section"
    },
    "Contractor shall not disparage Elite, or any of its affiliated companies, employees, officers, agents or contractors or otherwise act in a fashion designed to injure the business of Elite. This provision will not apply to truthful comments in response to a lawful subpoena or other legal process. In the event of a violation of this Section, the Parties agree that damages will difficult to determine, but are nevertheless real and substantial and therefore agree to liquidated damages in the amount equal to $5,000 for each incident of disparagement. Continuous statements made on separate dates, or if on the same date to separate people, shall be considered separate incidents each resulting in liquidated damages in the aforesaid amount. Such liquidated damages are fair and reasonable.\\n\\n",
    {
      "text": "Section XV:  Disputes, Jurisdiction, Mediation\\n",
      "style": "section"
    },
    "In the event of a dispute regarding this Agreement or the relationship or business dealings between the Parties, the following shall apply:\\n\\n",
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Negotiations/Mediation.  ",
          "bold": true,
          "italics": true
        },
        "The Parties shall first attempt in good faith to resolve any dispute through private negotiations. If the dispute is not resolved within 30-days of the first written notice of the dispute, the dispute shall be submitted for mediation in the City and County of Denver or the County of Arapahoe, Colorado to the Judicial Arbitration and Mediation Service (“JAMS”), or another mutually agreeable mediator, in accordance with the Mediation Rules of JAMS."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Mandatory Arbitration.  ",
          "bold": true,
          "italics": true
        },
        "Any dispute not resolved by mediation as set forth above will be submitted for mandatory arbitration in the City and County of Denver or the County of Arapahoe, Colorado to JAMS, or another mutually agreeable arbitrator. All disputes shall be arbitrated in accordance with the Comprehensive Rules of Arbitration of JAMS. The Parties adopt the Optional Appeals Procedures of JAMS. All costs of arbitration shall be shared equally between the Parties."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Award.  ",
          "bold": true,
          "italics": true
        },
        "The Final Award issued by the arbitrator shall not include comprehensive findings of fact and conclusions of law. Judgment upon the Final Award may be entered in any Colorado Court that has jurisdiction."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Jury Trial.  ",
          "bold": true,
          "italics": true
        },
        "THE PARTIES WAIVE ANY RIGHT TO A TRIAL BY JURY OR BY A JUDGE."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Attorneys’ Fees.  ",
          "bold": true,
          "italics": true
        },
        "In the event of any arbitration or litigation between the Parties related to this Agreement, the prevailing Party shall be entitled to recover its reasonable attorneys’ fees."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Damage Limitations.  ",
          "bold": true,
          "italics": true
        },
        "Elite will not be liable to Contractor for any incidental, indirect, special, or consequential damages of any kind including, but not limited to, any loss of business, loss of income, or loss of profit, even if advised of the possibility of such damage or if such damage could have been reasonably foreseen. In the event of any claim by Contractor against Elite, Contractor’s remedies shall be solely limited to the assets of Elite. No officer, director, employee, or agent of Elite shall have any personal liability to Contractor for any claim of Contractor arising out of this Agreement or the relationship between Elite and Contractor. If any such claim exists in law or equity against an officer, director, or other employee or independent contractor of Elite, Contractor waives such claim."
      ],
      "style": "para"
    },
    {
      "text": "Section XVI:  Miscellaneous\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Execution.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement may be executed in one or more counterparts, each of which shall constitute one and the same instrument. Execution may be by electronic signature wherein delivery shall be deemed completed by e-mail if there is electronic confirmation of receipt and opening of the e-mail by the recipient or by facsimile transmission with confirmation of delivery to the recipient."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Complete Agreement.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement contains a complete Agreement concerning the contractual relationship between Contractor and  Elite and shall supersede all agreements between the Parties. Contractor acknowledges that Elite has made no further representation regarding the terms of this relationship."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Assignment.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall not have the right to assign this Agreement."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Savings Clause and Severability.  ",
          "bold": true,
          "italics": true
        },
        "If in any action before any Court or tribunal empowered to enforce the terms and conditions herein, any portion or section of this Agreement is found to be unenforceable, illegal, or unlawful for any reason, then such term, restriction, remedy, portion, section, or covenant shall be deemed modified to the extent necessary to make it enforceable. In the event that any of the terms and conditions herein are declared invalid, unenforceable, or void for any reason whatsoever, the remaining terms and conditions shall be in full force and effect and binding upon the Parties herein as if the invalid, unenforceable, or void terms were not made a part hereof."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Waiver.  ",
          "bold": true,
          "italics": true
        },
        "The failure of either Party to exercise any right shall not be construed to be a waiver unless agreed upon in writing. A waiver in any one instance will not constitute an amendment to this Agreement or indicate any continued waivers of such right on any other occasion."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Survival.  ",
          "bold": true,
          "italics": true
        },
        "The provisions of this Agreement that by their nature continue after termination will survive the expiration, termination, or cancellation of this Agreement including, but not limited to, §§IX-XV."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "G.    ",
          "style": "bullet"
        },
        {
          "text": "Modifications.  ",
          "bold": true,
          "italics": true
        },
        "No waiver or modification of this Agreement or any covenants herein shall be valid unless made in writing and duly executed by both Parties. No evidence of any waiver or modification shall be offered or received into evidence or any proceeding for arbitration or litigation between the Parties unless such waiver or modification is in writing, duly executed by both Parties."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "H.    ",
          "style": "bullet"
        },
        {
          "text": "Attorneys' Fees.  ",
          "bold": true,
          "italics": true
        },
        "In the event any Party violates any of the terms herein, the defaulting Party shall be liable for the reasonable attorney's fees of the non-defaulting Party incurred as a result of enforcing the terms herein whether or not litigation, mediation, or arbitration is commenced."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "I.    ",
          "style": "bullet"
        },
        {
          "text": "Law.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement shall be governed and controlled by the laws of Colorado and the sole jurisdiction and the venue for hearing any matters arising out of, or related to, this Agreement shall be in City and County of Denver, Colorado."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "J.    ",
          "style": "bullet"
        },
        {
          "text": "Assignability.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement shall inure to the benefit of, and shall be binding on, Elite and any entity with which Elite may merge or assign its rights and duties under this Agreement."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "K.    ",
          "style": "bullet"
        },
        {
          "text": "Notices.  ",
          "bold": true,
          "italics": true
        },
        "Any notice required herein shall be effective three days after mailing Certified Mail, in the U.S. Mail, postage prepaid or upon actual receipt if hand-delivered or forwarded by overnight carrier. A notice transmitted and delivered by fax or e-mail or other electronic means shall be effective if there is proof of delivery in which case the effective date shall be the date of delivery. Notice shall be made to the addresses set forth above."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "L.    ",
          "style": "bullet"
        },
        {
          "text": "Time is of the Essence.  ",
          "bold": true,
          "italics": true
        },
        "Time is of the essence in the performance of any duty or requirement in this Agreement and a significant and material term of this Agreement."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "M.    ",
          "style": "bullet"
        },
        {
          "text": "Negotiated.  ",
          "bold": true,
          "italics": true
        },
        "The Parties have independently, separately, and freely negotiated each provision of this Contract as if all Parties drafted this Contract. The Parties, therefore, waive any statutory or common-law presumption that would serve to have this document construed in favor of, or against, either Party."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "N.    ",
          "style": "bullet"
        },
        {
          "text": "Headings.  ",
          "bold": true,
          "italics": true
        },
        "The headings of the Articles herein are inserted for convenience only and are not intended to affect the meaning or interpretation of this Agreement."
      ],
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "text": "BY OUR SIGNATURES WE AGREE TO THE ABOVE TERMS.",
      "bold": true,
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "text": [
        {
          "text": "Contractor:\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{userName}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": [
        {
          "text": "DBA:\\t\\t\\t\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{companyName}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": [
        {
          "text": "Date:\\t\\t\\t\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{date}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": "Signature:",
      "bold": true
    },
    {
      "canvas": [
        {
          "type": "line",
          "x1": 75,
          "y1": 0,
          "x2": 210,
          "y2": 0,
          "lineWidth": 1
        }
      ]
    },
    {
      "image": "{{{signature}}}",
      "fit": [
        90,
        250
      ],
      "margin": [
        85,
        -20,
        0,
        0
      ]
    },
    {
      "text": [
        "Elite Logistics, Inc.\\n\\n"
      ],
      "bold": true,
      "margin": [
        0,
        100,
        0,
        0
      ]
    },
    {
      "text": [
        {
          "text": "Date:\\t\\t\\t\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{date}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": "Signature:",
      "bold": true
    },
    {
      "canvas": [
        {
          "type": "line",
          "x1": 75,
          "y1": 0,
          "x2": 210,
          "y2": 0,
          "lineWidth": 1
        }
      ]
    },
    {
      "image": "{{{brentSig}}}",
      "fit": [
        90,
        250
      ],
      "margin": [
        85,
        -20,
        0,
        0
      ]
    },
    {
      "text": "By: Brent LaFave, President",
      "margin": [
        75,
        3,
        0,
        0
      ],
      "pageBreak": "after"
    },
    {
      "text": "Exhibit A\\nPayment Schedule",
      "alignment": "center",
      "bold": true,
      "fontSize": 12,
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "ol": [
        {
          "text": "Contractor shall be compensated at a rate commensurate with the vehicle type used to complete each Assignment, as set out in the Compensation Rate Per Vehicle table below. Notwithstanding the aforesaid, at no time shall Contractor be paid for days or partial days that Contractor spends fulfilling an Assignment that are in excess of a reasonable time necessary to fulfill the Assignment as determined by Elite in its sole discretion. In the event that Contractor is unable or unwilling to complete an Assignment, the compensation shall be adjusted by Elite, taking into consideration the amount of the Assignment completed by Contractor and the damages caused to Elite as a result of the intentional or negligent acts of Contractor.",
          "margin": [
            0,
            0,
            0,
            8
          ]
        },
        {
          "text": "Contractor shall be compensated for special deliveries (generally deliveries that will take less than 4 hours) and fuel at rates established between Elite and Contractor prior to commencing the delivery.",
          "margin": [
            0,
            0,
            0,
            8
          ]
        },
        {
          "text": "Elite shall partially reimburse Contractor for fuel used by Contractor in fulfilling an Assignment at a rate determined by a sliding scale, as illustrated by the example fuel reimbursement table below. The rate may vary from Assignment to Assignment based on the agreement between Elite and its customer. The reimbursement is based on a fuel price of $3.00/gallon (see the example fuel reimbursement table below) for regular unleaded gas, an estimated average miles per gallon for delivery vehicles used by contractors of Elite, and an average number of miles per Assignment of Elite contractors. The reimbursement may, but need not, be adjusted up or down by Elite, in its sole discretion, with the price of regular unleaded gas established by the most recent “Fuel Gauge Report” of the American Automobile Association and further based upon fuel charges by Elite to Client. Current reimbursement values can be found in the Fuel tab of the Elite Logistics Driver application.",
          "margin": [
            0,
            0,
            0,
            8
          ]
        }
      ]
    },
    {
      "text": "Compensation Rate Per Vehicle:",
      "fontSize": 12,
      "bold": true,
      "margin": [
        0,
        20,
        0,
        8
      ]
    },
    {
      "style": "tableExample",
      "table": {
        "alignment": "left",
        "headerRows": 1,
        "body": [
          [
            {
              "text": "Vehicle",
              "style": "tableHeader"
            },
            {
              "text": "Compensation",
              "style": "tableHeader"
            }
          ],
          "{{{invite_vehicles}}}"
        ]
      },
      "layout": "headerLineOnly"
    },
    {
      "text": [
        {
          "text": "Compensation Notes:\\t",
          "bold": true
        },
        {
          "text": "{{{invite_payNotes}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": "Fuel Reimbursement Table (Sample):",
      "fontSize": 12,
      "bold": true,
      "margin": [
        0,
        0,
        0,
        8
      ]
    },
    {
      "style": "tableExample",
      "table": {
        "headerRows": 1,
        "body": [
          [
            {
              "text": "Fuel Price Range",
              "style": "tableHeader"
            },
            {
              "text": "Per Completed Assignment",
              "style": "tableHeader"
            }
          ],
          [
            "$3.01 - $3.10",
            "$6.36"
          ],
          [
            "$3.11 - $3.20",
            "$7.45"
          ],
          [
            "$3.21 - $3.30",
            "$8.67"
          ],
          [
            "$3.31 - $3.40",
            "$9.89"
          ],
          [
            "$3.41 - $3.50",
            "$11.11"
          ],
          [
            "$3.51 - $3.60",
            "$12.33"
          ],
          [
            "$3.61 - $3.70",
            "$13.55"
          ],
          [
            "$3.71 - $3.80",
            "$14.77"
          ],
          [
            "$3.81 - $3.90",
            "$15.99"
          ],
          [
            "$3.91 - $4.00",
            "$17.21"
          ]
        ]
      },
      "layout": "headerLineOnly"
    }
  ],
  "defaultStyle": {
    "fontSize": 9.5,
    "bold": false,
    "columnGap": 125
  },
  "styles": {
    "listitem": {
      "italics": true,
      "margin": [
        0,
        0,
        0,
        9
      ]
    },
    "label": {
      "bold": true
    },
    "link": {
      "color": "#333",
      "fontSize": 8
    },
    "para": {
      "margin": [
        0,
        0,
        0,
        8
      ]
    },
    "section": {
      "bold": true,
      "margin": [
        0,
        2,
        0,
        4
      ]
    },
    "dark": {
      "bold": true
    },
    "bullet": {
      "margin": [
        0,
        0,
        10,
        0
      ]
    },
    "header": {
      "fontSize": 18,
      "bold": true,
      "margin": [
        0,
        0,
        0,
        10
      ]
    },
    "tableExample": {
      "margin": [
        0,
        5,
        0,
        15
      ],
      "alignment": "center"
    },
    "tableHeader": {
      "bold": true,
      "fontSize": 10,
      "color": "black"
    }
  },
  "images": {
    "logo": "data:image/png;base64,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"
  }
}
          `
          */
    }

    getDocStructure(args) {
        let dd = Mustache.render(this.json, args)
        let obj = JSON.parse(dd)

        return obj
    }
}
